module.exports = __webpack_public_path__ + "img/7.ec1e7a28.jpg";